export enum OrderManualTaskTemplateTypes {
  Generic = "Generic",
  FileFixing = "FileFixing",
}
